import React, { useEffect, useState } from 'react';
import { PIMCORE_CONTENT_BASE_URL } from '../../utils/Pimcore';
import BreadCrumbs from '../common/BreadCrumbs';
import ReusableTabs from '../common/ReusableTabs';
import investorRelationHeaderImage from '../../static/investor_image/investorHeader.png';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import { ResourceLibraryAssetItem } from '../../graphql/pimcore/modules/resourceLibrary/types/resourceLibraryItems';
import { sanitizeHtml } from '../../utils/htmlUtils';
import { toUrl } from '@/utils/convertImagePath';

interface HtmlAssetViewerProps {
    assetItem: ResourceLibraryAssetItem;
}

const HtmlAssetViewer: React.FC<HtmlAssetViewerProps> = ({ assetItem }) => {
    const asset = assetItem.asset!;
    const [htmlContent, setHtmlContent] = useState<string>('');
    const [htmlLoading, setHtmlLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchHtmlContent = async () => {
            setHtmlLoading(true);
            try {
                const assetUrl = `${PIMCORE_CONTENT_BASE_URL}${asset.fullpath}`;
                const response = await fetch(assetUrl);
                if (!response.ok) {
                    console.error('Error fetching HTML content:', response);
                }
                const text = await response.text();
                setHtmlContent(text);
            } catch (e) {
                console.error('Error fetching HTML content:', e);
            } finally {
                setHtmlLoading(false);
            }
        };
        fetchHtmlContent();
    }, [asset.fullpath]);

    if (htmlLoading) return <div className="mid-width">Loading content...</div>;

    const sanitized = sanitizeHtml(htmlContent);

    return (
        <ReusableTabs
            backgroundColor="#ffffff"
            bannerImage={toUrl(investorRelationHeaderImage)}
            bannerTitle={assetItem.name}
            bannerDescription={assetItem.name.length < 100 ? assetItem.description : ''}
            tabLabels={[]}
            tabKeys={['']}
            tabContents={[
                <div className="mid-width" key="html">
                    <div className="html-pages-wrapper">
                        <div dangerouslySetInnerHTML={{ __html: sanitized }} />
                    </div>
                </div>,
            ]}
            bannerFontStyle={styles.bannerFont}
            subBannerFontStyle={styles.bannerFont2}
            pageName="browseAllProductHome"
            showTabs={false}
            breadcrumbs={<BreadCrumbs navigationPath="/Home/SalesAndResources/ResourceLibrary" />}
        />
    );
};

export default HtmlAssetViewer;
